import { useAppDispatch, useAppSelector, useHandlePageNavigate } from "./hooks";
import {
  pullPhoneReportAsync,
  selectAllReportNotesList,
  selectPhoneReportStatus,
} from "../features/reports/reportsSlice";
import { useLocation } from "react-router-dom";

import { PullPhoneReportParams } from "../features/reports/reportTypes";
import { setPhoneSearch } from "../features/multisearch/multisearchSlice";
import { useGetSpecificReportNotesDispatch } from "./notesHook";
import { sendMemberEventAsync } from "../features/admin/adminSlice";

type UsePhoneReportHook = () => (
  phoneNumber: PullPhoneReportParams,
  pullLocation: string,
) => void;

/* Pull Phone Report */
const usePhoneReportDispatch: UsePhoneReportHook = () => {
  const dispatch = useAppDispatch();
  const reportStatus = useAppSelector(selectPhoneReportStatus);
  const pageNavigate = useHandlePageNavigate();
  const location = useLocation();
  const allReportNotesList = useAppSelector(selectAllReportNotesList);
  const getSpecificReportNotes = useGetSpecificReportNotesDispatch();

  const pullPhoneReport = (
    phoneNumber: PullPhoneReportParams,
    pullLocation: string,
  ) => {
    if (reportStatus === "loading") return;
    if (location.pathname !== "/phone-report") {
      pageNavigate("/phone-report");
    } else {
      window.scroll(0, 0);
    }
    dispatch(pullPhoneReportAsync(phoneNumber))
      .unwrap()
      .then(result => {
        if (result.success) {
          dispatch(setPhoneSearch(phoneNumber));
          if (
            allReportNotesList?.some(
              notes =>
                notes &&
                notes.reportType === "phone" &&
                notes.token === phoneNumber,
            )
          ) {
            getSpecificReportNotes({
              reportType: "phone",
              reportParams: {
                phone: phoneNumber,
              },
            });
          }
          dispatch(
            sendMemberEventAsync({
              EventAction: "Search",
              EventCategory: "Phone",
              MetaData: JSON.stringify({ "pull location": pullLocation }),
            }),
          );
        }
      })
      .catch(error => {
        console.log(error.message);
        pageNavigate("/");
      });
  };
  return pullPhoneReport;
};

export { usePhoneReportDispatch };
